import React from "react";
import { Link } from "react-router-dom";
import sidebarHelper from "../../../helpers/sidebar";

function ManageCampaignMenu({ openItem = null, activeItem = null }) {
  return (
    <li
      className={`nav-item has-treeview 
          ${sidebarHelper.checkOpenItem(openItem, "manage-campaigns")} `}
    >
      <a
        href="# "
        className={`nav-link  
          ${sidebarHelper.checkActiveItem(openItem, "manage-campaigns")} `}
      >
        <i className="nav-icon fa fa-tasks "></i>
        <p>
          مدیریت کمپین ها
          <i className="right fa fa-angle-left"></i>
        </p>
      </a>

      <ul className="nav nav-treeview">
        <li className="nav-item">
          <Link
            to="/campaigns/manage/banner/simple/all"
            className={`nav-link  
              ${sidebarHelper.checkActiveItem(
                activeItem,
                "all-campaign-banner"
              )} `}
          >
            <i className="fa fa-image nav-icon"></i>
            <p>کمپین های بنری</p>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/campaigns/manage/banner-alternative/all"
            className={`nav-link  
              ${sidebarHelper.checkActiveItem(
                activeItem,
                "all-campaign-banner-alternative"
              )} `}
          >
            <i className="fa fa-image nav-icon"></i>
            <p>کمپین های بنری جایگزین</p>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/campaigns/manage/native/simple/all"
            className={`nav-link  
              ${sidebarHelper.checkActiveItem(
                activeItem,
                "all-campaign-native"
              )} `}
          >
            <i className="fa fa-file nav-icon"></i>
            <p>کمپین های همسان</p>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/campaigns/manage/push/simple/all"
            className={`nav-link  
              ${sidebarHelper.checkActiveItem(
                activeItem,
                "all-campaign-push"
              )} `}
          >
            <i className="fa fa-bell nav-icon"></i>
            <p>کمپین های پوش</p>
          </Link>
        </li>
      </ul>
    </li>
  );
}
export default ManageCampaignMenu;
